export const SIDENAV_LIST_LABELS = {
  closeSession: 'Cerrar Sesión',
  planDevelopment: 'Plan de desarrollo (PDD)',
  annualAcquisitionPlan: 'Plan anual de adquisiciones (PAA)',
  operationalInvestmentPlan: 'Plan operativo de inversiones (POAI)',
  administration: 'Administración',
  paa: 'PAA',
  taskTray: 'Bandeja de tareas',
  requestedModifications: 'Modificaciones solicitadas',
  reports: 'Reportes',
  parameters: 'Parametros',
  dependencies: 'Dependencias',
  modalidadesSeleccion: 'Modalidades de Selección',
  actuacionesContractuales: 'Actuaciones Contractuales',
  tiposContrato: 'Tipos de Contrato',
  perfiles: 'Perfiles',
  rangosSalariales: 'Rangos Salariales',
  contratos: 'Contratos',
  empty: 'Empy'
};
